// dependencies
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

// contexts
import { useStorage } from "../../contexts/StorageContext"

// components
import SecondaryBtn from "../../components/btns/SecondaryBtn"

// hook
import { useDeleteProject } from "../../hooks/useFirebase"


const DeleteProject = ({ id, projectTitle }) => {
    const navigate = useNavigate()
    // contexts
    const { storage } = useStorage()
    // hook
    const { deleteProject } = useDeleteProject()


    // handle delete project's doc and imgs folder
    const handleDelete = async () => {
        if (!window.confirm("Are you sure you want to delete?")) return

        try {
            await deleteProject(id, projectTitle, storage)
            toast("Project Deleted Successfully", { type: "success" })
        } catch (error) {
            toast("Error Deleting Project", { type: "error" })
            console.error(error)
        } finally {
            navigate("/projects")
        }
    }

    return (
        <div>
            <SecondaryBtn text={"Delete Project"} onClick={handleDelete} />
        </div>
    )
}

export default DeleteProject